import React, { useEffect, useMemo } from "react";
import { Stack } from "../../../components/DesignSystem";
import Formatter from "../../../helpers/Formatter";
import { Control } from "react-hook-form";

import AmountPicker from "../../../components/AmountPicker/AmountPicker";

const SELECT_DENOMINATION_AMOUNT_TEXT = "Select an amount to purchase";

interface GiftCardSelectorProps {
  denominations: number[];
  deviceHasInternet: boolean;
  control: Control<any>;
  name: string;
  setValue: any;
}

export default function GiftCardSelector({
  denominations,
  deviceHasInternet,
  setValue,
  control,
  name,
}: GiftCardSelectorProps) {
  const options = useMemo(
    () =>
      denominations.map((denomination) => ({
        value: denomination,
        label: Formatter.formatCurrency(denomination / 100, "CAD", 0),
        disabled: !deviceHasInternet,
      })),
    [denominations, deviceHasInternet]
  );

  return (
    <Stack gap="sm" align={{ mobile: "left", tablet: "left", desktop: "left" }}>
      <AmountPicker
        title={SELECT_DENOMINATION_AMOUNT_TEXT}
        description={""}
        presentValues={options}
        hasCustomValue={true}
        onChange={(e) => {
          if (e?.value && !Number.isNaN(e.value)) {
            if ((Number(e.value) / 100 ) % 5 === 0) {              
              setValue("amount", e.value.toString());
            } else {        
              setValue("amount", 0);
            }
          }
        }}
        customDescription={
          "Enter an amount less than $500 and in multiples of $5 (e.g., $25, $45, $100)."
        }
        selectedAmount={control?._formValues?.amount}
      ></AmountPicker>
      <>
        {/* <Inline>
          <RadioGroup
            label={SELECT_DENOMINATION_AMOUNT_TEXT}
            options={options}
            control={control}
            name={name}
            direction="horizontal"
            align={{ mobile: "start", tablet: "start", desktop: "start" }}
          />
          <View style={[Classes.flex, Classes.gap0]}>
            <CheckBox
              onPress={() => {
                setValue("amount", null);
                setEnableCustomValue(!enableCustomValue);
              }}
              containerStyle={[
                Classes.flex,
                Classes.selfCenter,
                Classes.p0,
                Classes.m0,
              ]}
              checked={enableCustomValue}
            />
            <Text
              onPress={() => {
                setValue("amount", null);
                setEnableCustomValue(!enableCustomValue);
              }}
              style={[Classes.flex, Classes.selfCenter]}
            >
              Use custom amount
            </Text>
          </View>
        </Inline>

        {enableCustomValue && (
          <View style={[Classes.mt8]}>
            <Text>
              Enter an amount less than $500 and in multiples of $5 (e.g., $25,
              $45, $100).
            </Text>
            <Controller
              control={control}
              name="amount"
              render={({ field: { value, onBlur } }) => (
                <TextInput
                  maxLength={3}
                  keyboardType={"number-pad"}
                  placeholder="Custom amount"
                  style={[
                    formStyle.textInput,
                    Classes.mt8,
                    {
                      width: 150,
                      borderColor: value && value % 5 === 0 ? "green" : "red",
                    },
                  ]}
                  placeholderTextColor="#aaa"
                  onChangeText={(Text: string) => {
                    if (isValidNumber(Text)) {
                      setCustomValue(Text);
                      if (isValidCustomValue(Text)) {
                        const val = (Number(Text) * 100).toString();
                        setValue("amount", val);
                      } else {
                        setValue("amount", null);
                      }
                    } else {
                      setCustomValue("");
                    }
                  }}
                  value={customValue}
                />
              )}
            />
          </View>
        )} */}
      </>
    </Stack>
  );
}
